import { useContext, useEffect, useState } from "react";
import { Button } from "../../../components/button/Button";
import { ModalContext } from "../../../components/Modal";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { changeCorp, getCorpList } from "../../../redux/userSlice";
import Loading from "../../../components/Loading";
import RadioButton from "../../../components/RadioButton";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { showNotification } from "../../../redux/notificationSlice";

const ChangeSystemModel = () => {
  const modalContext = useContext(ModalContext);
  const { corp, corpList } = useSelector((state: RootState) => state.user.user);

  const dispatch = useDispatch<AppDispatch>();
  const close = modalContext?.close ?? (() => {});
  const [isLoading, setIsLoading] = useState(false);
  const [isAppling, setIsAppling] = useState(false);
  const [corpData, setCorpData] = useState([]);
  const [selectedCorp, setSelectedCorp] = useState(corp.corpCode);
  // const fetchCorpList = async () => {
  //   setIsLoading(true);
  //   await dispatch(getCorpList())
  //     .then((res) => {
  //       if (res.type.includes("fulfilled")) {
  //         if (corpList?.length > 0) {
  //           const corpOptions = corpList.map((corp: any, index: number) => {
  //             return {
  //               value: corp.corpCode || "",
  //               label: corp.corpName || "",
  //             };
  //           });
  //           setCorpData(corpOptions);
  //         }
  //         setIsLoading(false);
  //       } else {
  //         setIsLoading(false);
  //         dispatch(
  //           showNotification({
  //             message: "Something went wrong!",
  //             duration: 3000,
  //             isError: true,
  //           }),
  //         );
  //       }
  //     })
  //     .catch((err) => {
  //       dispatch(
  //         showNotification({
  //           message: "Something went wrong!",
  //           duration: 3000,
  //           isError: true,
  //         }),
  //       );
  //       setIsLoading(false);
  //     });
  // };

  useEffect(() => {
    if (corpList.length > 0) {
      const corpOptions: any = corpList.map((corp: any, index: number) => {
        return {
          value: corp.corpCode || "",
          label: corp.corpName || "",
        };
      });
      setCorpData(corpOptions);
    }
  }, [corpList]);
  const handleCorpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedCorp(e.target.value);
  };

  const handleApply = () => {
    if (selectedCorp == corp.corpCode) {
      close();
      return;
    }
    setIsAppling(true);
    const data: any = new URLSearchParams();
    data.append("corp", selectedCorp);

    dispatch(changeCorp(data))
      .then((res: any) => {
        if (res.type.includes("fulfilled") && res.payload != "Error") {
          // setIsAppling(false);

          window.location.replace(res.payload);
        } else {
          dispatch(
            showNotification({
              message: "Something went wrong!",
              duration: 3000,
              isError: true,
            }),
          );
        }
      })
      .catch((err) => {
        dispatch(
          showNotification({
            message: "Something went wrong!",
            duration: 3000,
            isError: true,
          }),
        );
      });
  };
  return (
    <div className="dialog-container change-system">
      <div className="dialog-header">
        <div className="dialog-title">
          <h3>Change System</h3>
        </div>
      </div>

      <div
        style={{
          padding: "15px 20px",
          display: "flex",
          flexDirection: "column",
          gap: 14,
          //   minHeight: 100,
          maxHeight: 320,
          overflow: "auto",
          flex: 1,
        }}
      >
        {isLoading ? (
          <Loading show={isLoading} />
        ) : corpData.length > 0 ? (
          corpData.map((corp: any, index) => {
            return (
              <RadioButton
                key={corp.value}
                onChange={handleCorpChange}
                checked={corp.value == selectedCorp}
                label={corp.label}
                name="corporations"
                value={corp.value}
              />
            );
          })
        ) : (
          <div>No corporations found.</div>
        )}
      </div>
      <div className="dialog-footer">
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Button
            className="btn sm"
            color="primary"
            variant="outline"
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            className="btn sm"
            disabled={selectedCorp == ""}
            color="primary"
            onClick={handleApply}
          >
            Apply
          </Button>
        </div>
      </div>
      <LoadingOverlay show={isAppling} />
    </div>
  );
};

export default ChangeSystemModel;
